import { Linking } from 'react-native';
import { createLogger } from '@/lib/logger';

const log = createLogger('URL_GUARD');

let installed = false;

export function installUrlGuard(): void {
  if (!__DEV__ || installed) {
    return;
  }

  installed = true;
  const original = Linking.openURL.bind(Linking);

  Linking.openURL = (async (url: string) => {
    const isString = typeof url === 'string';
    const trimmed = isString ? url.trim() : '';
    const hasScheme =
      trimmed.startsWith('http://') || trimmed.startsWith('https://');
    const isBareScheme = trimmed === 'http://' || trimmed === 'https://';

    let isParsable = false;
    if (hasScheme && !isBareScheme) {
      try {
        new URL(trimmed);
        isParsable = true;
      } catch {
        isParsable = false;
      }
    }

    if (!isString || trimmed.length === 0 || !hasScheme || isBareScheme || !isParsable) {
      const stack = new Error('openURL stack').stack
        ?.split('\n')
        .slice(0, 6)
        .join('\n');
      log.warn('[URL_GUARD] blocked invalid openURL', { url, stack });
      return false;
    }

    return await original(trimmed);
  }) as typeof Linking.openURL;
}
